<app-title title="{{ 'PAGINA_GESTAO_PESSOA.TITULO' | translate }}"></app-title>
<!-- Perfil da Pessoa -->
<section>
  <div
    class="n-container p-5 n-card2 flex flex-wrap flex-column md:flex-row md:justify-content-between row-gap-5 column-gap-4"
  >
    <div class="row">
      <div class="img-logo">
        <div class="img">
          <img src="../../../assets/img/logo-portal-light.png" alt="" />
          <div class="edit">
            <p-button
              icon="pi pi-pencil"
              [rounded]="true"
              [text]="true"
              [outlined]="true"
              width="100%"
            ></p-button>
          </div>
        </div>
      </div>
      <div class="info">
        <div>
          <h5>Nome</h5>
          <p>{{pessoa.nome}}</p>
        </div>
        <div>
          <h5>Telefone</h5>
          <p>{{pessoa.telefone}}</p>
        </div>
        <div>
          <h5>E-mail</h5>
          <p>{{pessoa.email}}</p>
        </div>
        <div>
          <h5>Cpf/Cnpj</h5>
          <p>{{pessoa.cpfCnpj}}</p>
        </div>
        <div>
          <h5>Logradouro</h5>
          <p>{{pessoa.endereco.logradouro}}</p>
        </div>
        <div>
          <h5>Número</h5>
          <p>{{pessoa.endereco.numero}}</p>
        </div>
        <div>
          <h5>Bairro</h5>
          <p>{{pessoa.endereco.bairro}}</p>
        </div>
        <div>
          <h5>Cidade</h5>
          <p>{{pessoa.endereco.cidade}}</p>
        </div>
        <div>
          <h5>Complemento</h5>
          <p>{{pessoa.endereco.complemento }}</p>
        </div>
        <div>
          <h5>Estado</h5>
          <p>{{pessoa.endereco.estado}}</p>
        </div>
        <div>
          <h5>Pais</h5>
          <p>{{pessoa.endereco.pais}}</p>
        </div>
        <div>
          <h5>Cep</h5>
          <p>{{pessoa.endereco.codPostal}}</p>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End -->

<!-- Associar Pessoa -->
<section class="section-margin">
  <div class="n-card2 p-4">
    <div class="c-cabecalho">
      <h3>Associações</h3>

      <button
        type="button"
        pButton
        pRipple
        icon="pi pi-plus"
        (click)="showAssociarPessoaDialog()"
      ></button>
    </div>
    <p-table
      [value]="pessoas"
      [tableStyle]="{'min-width': '50rem'}"
      [paginator]="true"
      [rows]="5"
      [tableStyle]="{ 'min-width': '50rem' }"
      [rowsPerPageOptions]="[5, 10, 20]"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th>{{ 'PAGINA_GESTAO_PESSOA.TELEFONE' | translate }}</th>
          <th>{{ 'PAGINA_GESTAO_PESSOA.NOME' | translate }}</th>
          <th>{{ 'PAGINA_GESTAO_PESSOA.ACOES' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-pessoa let-columns="columns">
        <tr>
          <td>{{pessoa.telefone}}</td>
          <td>{{pessoa.nome}}</td>
          <td>
            <button
              type="button"
              pButton
              pRipple
              icon="pi pi-trash"
              [rounded]="true"
              [text]="true"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>

<p-dialog
  header="Associar Pessoa"
  [modal]="true"
  [(visible)]="showAssociacaoDialog"
  [style]="{ width: '25rem' }"
>
  <span class="p-text-secondary block mb-5"
    >{{ 'PAGINA_GESTAO_PESSOA.MODAL_SUBTITLE' | translate }}</span
  >
  <div class="flex align-items-center gap-3 mb-3">
    <label for="Telefone" class="font-semibold w-6rem"
      >{{ 'PAGINA_GESTAO_PESSOA.TELEFONE' | translate }}</label
    >
    <input pInputText id="Telefone" class="flex-auto" autocomplete="off" />
  </div>
  <div class="flex align-items-center gap-3 mb-5">
    <label for="TipoPessoa" class="font-semibold w-6rem"
      >{{ 'PAGINA_GESTAO_PESSOA.TIPO' | translate }}</label
    >
    <p-dropdown
      id="TipoPessoa"
      [options]="tipoPessoaConst"
      optionLabel="description"
      placeholder="{{ 'PAGINA_GESTAO_PESSOA.STATUS' | translate }}"
      [showClear]="true"
    />
  </div>
  <div class="flex justify-content-end gap-2">
    <p-button
      label="{{ 'PAGINA_GESTAO_PESSOA.MODAL_CANCELAR' | translate }}"
      severity="secondary"
      (onClick)="showAssociacaoDialog = false"
    />
    <p-button
      label="{{ 'PAGINA_GESTAO_PESSOA.MODAL_SALVAR' | translate }}"
      (onClick)="showAssociacaoDialog = false"
    />
  </div>
</p-dialog>
<!-- End -->

<!-- Associar Plano -->
<section class="section-margin">
  <div class="n-card2 p-4">
    <div class="c-cabecalho">
      <h3>Planos</h3>
      <button
        type="button"
        pButton
        pRipple
        icon="pi pi-plus"
        (click)="showAssociarPlanoDialog()"
      ></button>
    </div>
    <p-table
      [value]="planosAssociados"
      [tableStyle]="{'min-width': '50rem'}"
      [paginator]="true"
      [rows]="5"
      [tableStyle]="{ 'min-width': '50rem' }"
      [rowsPerPageOptions]="[5, 10, 20]"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th>Plano</th>
          <th>Sistema</th>
          <th>Status</th>
          <th>Valor</th>
          <th>{{ 'PAGINA_GESTAO_PESSOA.ACOES' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-plano let-columns="columns">
        <tr>
          <td>{{plano.nome}}</td>
          <td>{{plano.aplicacao}}</td>
          <td>{{plano.Valor}}</td>
          <td>
            <button
              type="button"
              pButton
              pRipple
              icon="pi pi-trash"
              [rounded]="true"
              [text]="true"
              (click)="desvincularPlano(plano.id)"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
<p-dialog
  header="Adicionar plano"
  [modal]="true"
  [(visible)]="showPlanoDialog"
  [style]="{ width: '50rem' }"
>
  <div>
    <p-table
      [value]="planos"
      [(selection)]="planosSelecionados"
      [tableStyle]="{'min-width': '50rem'}"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
          <th>{{ 'PAGINA_PLANO.ID' | translate }}</th>
          <th>{{ 'PAGINA_PLANO.NOME' | translate }}</th>
          <th>{{ 'PAGINA_PLANO.APLICACAO' | translate }}</th>
          <th>{{ 'PAGINA_PLANO.VALOR' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-plano let-columns="columns">
        <tr>
          <td>
            <p-tableCheckbox [value]="plano" />
          </td>
          <td>{{plano.id}}</td>
          <td>{{plano.nome}}</td>
          <td>{{plano.aplicacao}}</td>
          <td>R$ {{plano.valor}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="flex justify-content-end gap-2">
    <p-button
      label="Cancel"
      severity="secondary"
      (onClick)="showPlanoDialog = false"
    />
    <p-button label="Save" type="submit" (onClick)="salvarAssociarPlano()" />
  </div>
</p-dialog>
<!-- End -->

<app-voltar></app-voltar>
